import React, { useEffect, useState } from "react";
import { ProposalPreviewRouter } from "views/app-views/sales-pipeline/smartproposal/proposalPreview";
import {
  fetchProposalDetailRequest,
  getBusinessProposalState,
  acceptProposalDetailRequest,
  updateViewTimeRequest,
} from "redux/reducers/public-proposal";
import {
  downloadProposalRequest,
  resetDownloadProposalState,
  getSmartProposalListState,
  publicLinkForProposalRequest,
  getPublicUrlState,
} from "redux/reducers/smart-proposal/index";
import { useDispatch, useSelector } from "react-redux";
import CustomizedDialogs from "components/shared-components/messagenotification/successmessage";
import moment from "moment";
import { Button, Modal, Input, Select, Menu, Dropdown } from "antd";
import { formatSuiteSectionTitle } from "utils/suiteDisplayUtils";
import {
  formatBusinessDaysHoursDisplay,
  formatFloorForProposal,
  isBusinessDayEnabled,
} from "views/app-views/sales-pipeline/smartproposal/businessHoursPerDayUtils";
import { buildLicenseFeeSlideData } from "views/app-views/sales-pipeline/smartproposal/proposalPreview/buildLicenseFeeSlideData";
import { buildSwPricingSlideData } from "views/app-views/sales-pipeline/smartproposal/proposalPreview/buildSwPricingSlideData";
import { declineOption } from "./mockDate";
import { Document, Page, pdfjs } from "react-pdf";
const { Option } = Select;

const { TextArea } = Input;

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const BusinessProposalComponent = (props) => {
  let createdProposal = props.dataAfterCreated;

  /**declear */
  const [rowvalue, setrowvalue] = useState({});
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isProposalDeclined, setIsProposalDeclined] = useState(false);
  const [message, setMessage] = useState("");
  const [proposalId, setProposalId] = useState("");
  const [viewTime, setViewTime] = useState("");
  const [isModalAcceptVisible, setIsModalAcceptVisible] = useState(false);
  const [isModalDeclineVisible, setIsModalDeclineVisible] = useState(false);
  const [acceptNotes, setAcceptNotes] = useState("");
  const [declineNote, setDeclineNote] = useState("");
  const [status, setStatus] = useState("");
  const [isDeclineNotes, setIsDeclineNotes] = useState(false);
  const [seclineTextNote, setSeclineTextNote] = useState("");
  const [isDeclineReasonBlank, setDeclineReasonBlank] = useState(false);
  const [actionStatus, setActionStatus] = useState("");
  const [pdfViewUrl, setPdfViewUrl] = useState("");
  const [isBusinessProposal, setBusinessProposal] = useState(true);
  const [numOfPages, setNumOfPages] = useState([1]);
  const [isShareModelVisible, setShareModelVisible] = useState(false);
  const [publicUrl, setPublicUrl] = useState("");
  const [totalHour, setTotalHour] = useState(0);
  const [selectedRange, setSelectedRange] = useState("");

  useEffect(() => {
    setBusinessProposal(true);
    let jwtToken = localStorage.getItem("auth_token");
    let status = props?.location?.pathname.split("/")[4];
    let id = props?.location?.pathname.split("/")[5];
    setProposalId(id);
    localStorage.setItem("pr", id);
    localStorage.setItem("cn", props?.location?.pathname.split("/")[3]);
    let token = props?.location?.search?.split("?token=")[1];
    
    if(jwtToken){
      localStorage.setItem("auth_token", jwtToken);
    }else{
      localStorage.setItem("auth_token", token);
      localStorage.setItem("isPublic", true);
    }
    
    let contactPerson = props?.location?.pathname.split("/")[3];
    setStatus(status);
    if (status !== "Won" && status !== "Lost") {
      let req = {
        id: id,
        status: getStatus(status),
        clientName: contactPerson.split("+").join(" "),
      };
      dispatch(fetchProposalDetailRequest(req));
    }

    setViewTime(new Date());
  }, [props.location.pathname, props.location.search, dispatch]);

  const getStatus = (status) => {
    if(status === "Sent(Draft)"){
      return "View";
    }else{
      return status;
    }
    // if (status === "Won" || status === "Lost" || status === "Deal") {
    //   return status;
    // }
    // return status === "Sent(Draft)" ? "View" : "Sent(Final)";
  };


  const publicLink = useSelector(getPublicUrlState);

  useEffect(() => {
    if (publicLink?.data) {
      setPublicUrl(publicLink?.data);
    }
  }, [publicLink?.data]);
  /**
   * getbusinessCenterListState subscribe
   */
  const businessProposal = useSelector(getBusinessProposalState);


  useEffect(() => {
    if (businessProposal?.fetchProposalDetail?.data?.data) {
      // let status = businessProposal?.fetchProposalDetail?.data?.data[0]?.status;
      setrowvalue(businessProposal?.fetchProposalDetail?.data?.data);
      // setPublicUrl(document?.URL);
      dispatch(publicLinkForProposalRequest(document?.URL));
      setTimeout(function () {
        setInterval(function () {
          updateViewTime(businessProposal?.fetchProposalDetail?.data?.data);
        }, 15000);
      }, 2);
    }
  }, [businessProposal?.fetchProposalDetail]);

  /**
   * getbusinessCenterListState subscribe
   */
  const acceptBusinessProposal = useSelector(getBusinessProposalState);
  useEffect(() => {
    if (acceptBusinessProposal?.acceptProposalDetail?.data?.data) {
      setIsModalVisible(true);
      setActionStatus(
        acceptBusinessProposal?.acceptProposalDetail?.data?.data?.status
      );
    }
  }, [acceptBusinessProposal?.acceptProposalDetail]);

  /**
   * close thank you model
   */
  const handleclose = () => {
    setIsModalVisible(false);
  };

  const showModalForAccept = () => {
    setIsModalAcceptVisible(true);
  };

  const updateViewTime = (data) => {
    let req = {
      time: 10,
      id: localStorage.getItem("pr"),
      viewsId: data?.totalViewTime[data?.totalViewTime?.length - 1]?.id,
    };
    dispatch(updateViewTimeRequest(req));
  };

  const handleOk = () => {
    setMessage("Proposal Accepted Successfully");
    setIsModalAcceptVisible(false);
    let req = {
      id: proposalId,
      acceptNote: acceptNotes,
      type: "Won",
      clientName: clientName(),
    };
    dispatch(acceptProposalDetailRequest(req));
  };

  const clientName = () => {
    if (rowvalue?.user?.name) {
      return rowvalue?.user?.name;
    }
  };

  const handleCancel = () => {
    setIsModalAcceptVisible(false);
  };

  const showModalForDecline = () => {
    setIsModalDeclineVisible(true);
  };

  const handleDecineOk = () => {
    if (
      (isDeclineNotes && seclineTextNote === "") ||
      (!isDeclineNotes && declineNote === "")
    ) {
      setDeclineReasonBlank(true);
      return;
    }
    setDeclineReasonBlank(false);
    setMessage("Proposal Declined Successfully");
    setIsModalDeclineVisible(false);
    let req = {
      id: proposalId,
      declineNote: isDeclineNotes ? seclineTextNote : declineNote,
      type: "Lost",
      clientName: clientName(),
    };
    dispatch(acceptProposalDetailRequest(req));
    setIsProposalDeclined(true);
  };

  const handleDeclineCancel = () => {
    setIsModalDeclineVisible(false);
  };
  const selectedDeclineNote = (value) => {
    setDeclineNote(value);
    if (value === "Others") {
      setIsDeclineNotes(true);
    } else {
      setIsDeclineNotes(false);
    }
  };

  function onDocumentLoadSuccess({ numPages }) {
    let pages = [];
    for (let i = 1; i <= numPages; ++i) {
      pages.push(i);
    }
    setNumOfPages(pages);
  }

  const handleShareOk = () => {
    setShareModelVisible(false);
    if (navigator?.clipboard) {
      navigator.clipboard.writeText(publicUrl);
    }
  };

  const calculateTotalHours = () => {
    const timeStart = new Date(`2000-01-01 ${rowvalue.businessHourStart}`);
    const timeEnd = new Date(`2000-01-01 ${rowvalue.businessHourEnd}`);
    if (timeEnd < timeStart) {
      timeEnd.setDate(timeEnd.getDate() + 1); // Adjust for the next day
    }

    const timeDifferenceMinutes = (timeEnd - timeStart) / 60000;
    const hours = Math.floor(timeDifferenceMinutes / 60);
    const minutes = timeDifferenceMinutes % 60;
    let totalHoursString;
    if (hours === 0) {
      totalHoursString = `${minutes} minutes`;
    } else {
      totalHoursString =
        minutes === 0 ? `${hours} hours` : `${hours} hours ${minutes} minutes`;
    }
    // const totalHoursString = minutes === 0 ? `${hours} hours` : `${hours} hours ${minutes} minutes`;
    setTotalHour(totalHoursString);
  };

  useEffect(() => {
    calculateTotalHours();
  }, [rowvalue]);

  const setDays = () => {
    const days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    const businessHourData = rowvalue?.businessHourData;
    const selectedDays = [];
    const excludedDays = [];

    for (const day of days) {
      const dayAvailability = businessHourData?.[day];
      if (isBusinessDayEnabled(dayAvailability)) {
        selectedDays.push(day);
      } else if (dayAvailability != null && String(dayAvailability).trim() !== "") {
        excludedDays.push(day);
      }
    }

    if (selectedDays.length === 0) {
      setSelectedRange("");
    } else if (selectedDays.length === 7) {
      setSelectedRange("Monday-Sunday");
    } else {
      let selectedRange = "";
      let isInCompleteRange = true;

      for (let i = 0; i < selectedDays.length - 1; i++) {
        const currentIndex = days.indexOf(selectedDays[i]);
        const nextIndex = days.indexOf(selectedDays[i + 1]);

        if (nextIndex !== currentIndex + 1) {
          isInCompleteRange = false;
          break;
        }
      }

      if (isInCompleteRange) {
        selectedRange = `${selectedDays[0]}-${
          selectedDays[selectedDays.length - 1]
        }`;
      } else {
        selectedRange = selectedDays.join(", ");
      }

      const excludedDaysStr =
        excludedDays.length > 0
          ? `Excluded Days (${excludedDays.join(", ")})`
          : "";
      setSelectedRange(`${selectedRange} ${excludedDaysStr}`);
    }
  };

  useEffect(() => {
    setDays();
  }, [rowvalue]);

  const handleShareCancel = () => {
    setShareModelVisible(false);
  };

  const menu1 = (
    <Menu>
      {rowvalue?.addLayout?.map((e, i) => {
        return (
          <Menu.Item key={i}>
            <span>
              <a href={e?.url}> {e?.name}</a>
              <span className="ml-5"></span>
            </span>
          </Menu.Item>
        );
      })}
      {rowvalue?.attachementDocument?.map((e, i) => {
        return (
          <Menu.Item key={i}>
            <span>
              <a href={e?.url}> {e?.name}</a>
            </span>
            <span className="ml-5"></span>
          </Menu.Item>
        );
      })}
      <Menu.Divider />
      <Menu.Item>
        <span onClick={printDocument}>smartproposal.pdf</span>
        <span className="ml-5"></span>
      </Menu.Item>
    </Menu>
  );

  function printDocument() {
    let dataPdf = {
      pdfData: [
        {
          name: "Client Requirement",
          value: rowvalue?.spaceUpdate === "Square Feet"
            ? rowvalue?.totalArea + " Square Feet"
            : rowvalue?.spaceUpdate === "Workstation"
              ? (rowvalue?.proposedWorkstation || rowvalue?.workstations || "") + " Workstation"
              : rowvalue?.spaceUpdate === "WholeSuite"
                ? formatSuiteSectionTitle(rowvalue)
                : "Virtual Seat",
          isRupee: "",
        },
        {
          name: "Requirement Breakup",
          value: rowvalue.requirementBreakup,
          isRupee: "",
        },
        {
          name: "Floor",
          value: formatFloorForProposal(rowvalue),
          isRupee: "",
        },
        {
          name: "Contract Term",
          value: rowvalue.contractTerm + " Months",
          isRupee: "",
        },
        {
          name: "Lock-in Period",
          value: rowvalue.lockInPeriod + " Months",
          isRupee: "",
        },
        {
          name: "Notice Period",
          value: rowvalue.noticePeriod + " Months post contract lock-in",
          isRupee: "",
        },
        {
          name: "Monthly Fixed Rental",
          value: rowvalue.monthlyRental + " + applicable taxes" || " ",
          isRupee: "S$",
        },
        {
          name: "Security Deposit",
          value: rowvalue.securityDeposit,
          isRupee: "S$",
        },
        {
          name: "Business Days & Hours",
          isRupee: "",
          value: formatBusinessDaysHoursDisplay(
            rowvalue,
            selectedRange,
            totalHour
          ),
        },
        {
          name: "No. of free four-wheeler parking",
          value: rowvalue.noOfFreeFourWheelerParking,
          isRupee: "",
        },
        {
          name: "No. of free two-wheeler parking",
          value: rowvalue.noOfFreeTwoWheelerParking,
          isRupee: "",
        },
        {
          name: "No. of chargeable four-wheeler parking",
          value: rowvalue.noOfChargeableFourWheelerParking,
          isRupee: "",
        },
        {
          name: "No. of chargeable two-wheeler parking",
          value: rowvalue.noOfChargeableTwoWheelerParking,
          isRupee: "",
        },
        {
          name: "Car Parking Charges",
          value:
            rowvalue.carParkingCharges +
            " + applicable taxes / per car / per month",
          isRupee: "S$",
        },
        {
          name: "Bike Parking Charges",
          value:
            rowvalue.bikeParkingCharges +
            " + applicable taxes / per bike / per month",
          isRupee: "S$",
        },
        {
          name: "Notes",
          value: rowvalue.notesToClient,
          isRupee: "",
        },
      ],
      address: rowvalue?.location?.name,
      userName: rowvalue.user.name,
      whoIsLeading:
        rowvalue.client && rowvalue.client.firstName
          ? rowvalue.client.firstName + " " + rowvalue.client.lastName
          : rowvalue.lead.firstName + " " + rowvalue.lead.lastName,
      password: "12345",
      proposalName: rowvalue?.proposalName,
      proposalTemplateKey:
        typeof rowvalue?.location?.proposalTemplateKey === "string"
          ? rowvalue.location.proposalTemplateKey.trim()
          : rowvalue?.location?.proposalTemplateKey,
      licenseFeeSlide: buildLicenseFeeSlideData(rowvalue),
      swPricingSlide: buildSwPricingSlideData(rowvalue),
    };
    dataPdf.pdfData = dataPdf.pdfData.filter((e) => {
      if (
        String(e?.value)?.indexOf("null") === -1 &&
        String(e?.value)?.indexOf("undefined") === -1
      ) {
        return e.value !== null;
      }
    });
    let req = {
      type: "proposal-pdf",
      data: dataPdf,
    };
    dispatch(downloadProposalRequest(req));
  }

  /**
   * callback for response
   */
  const downloadProposal = useSelector(getSmartProposalListState);
  useEffect(() => {
    if (downloadProposal?.downloadProposal?.data) {
      downloadPdf(downloadProposal?.downloadProposal?.data);
    }
  }, [downloadProposal?.downloadProposal]);

  const downloadPdf = (pdf) => {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = "businessProposal.pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    dispatch(resetDownloadProposalState());
  };

  const showPdfViewer = (value) => {
    setPdfViewUrl(value?.url);
    setBusinessProposal(false);
  };

  const showProposal = () => {
    setBusinessProposal(true);
  };



  return (
    <>
      <div>
        {/* chevron */}
        <div
          className="d-flex justify-content-between"
          style={{ height: "80px" }}
        >
          <div
            style={{
              width: "250px",
              marginTop: "22px",
              marginLeft: "17px",
            }}
          >
            <img
              src="/static/media/SW-newlogo.1b34b5c6.svg"
              alt="Portal UI logo"
            />
          </div>
          <div className="d-flex float-right">
            <div className="mt-4 ml-4">
              {" "}
              <button
                className="btn btn-ghost mr-1"
                style={{
                  fontSize: "12px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
                onClick={() => {
                  setShareModelVisible(true);
                }}
              >
                Share Link
              </button>
            </div>
            <div className="mt-4 ml-2">
              <Dropdown overlay={menu1} placement="topCenter">
                <button
                  className="btn btn-ghost mr-2"
                  style={{
                    fontSize: "12px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                  }}
                >
                  Download Files
                </button>
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="row g-0">
          <div className="col-sm-2">
            <div className="mt-4">
              <Menu mode="inline">
                <hr />
                <Menu.Item key={0}>
                  <span>
                    {" "}
                    <a onClick={(p) => showProposal()}>Business Proposal</a>
                  </span>
                </Menu.Item>
                <hr />
                {rowvalue?.addLayout?.map((e, i) => {
                  return (
                    <>
                      <Menu.Item key={i + 1}>
                        <span>
                          {" "}
                          <a onClick={(p) => showPdfViewer(e)}>{e?.name}</a>
                        </span>
                      </Menu.Item>
                      <hr />
                    </>
                  );
                })}
                {rowvalue?.attachementDocument?.map((e, i) => {
                  return (
                    <>
                      <Menu.Item key={i + rowvalue?.addLayout?.length + 1}>
                        <span>
                          {" "}
                          <a onClick={(p) => showPdfViewer(e)}>{e?.name}</a>
                        </span>
                      </Menu.Item>
                      <hr />
                    </>
                  );
                })}
              </Menu>
            </div>
          </div>
          <>
            <div id="businessProposal" className="col-sm-10 ">
              {isBusinessProposal ? (
                <div className="row border-left g-0">
                  <ProposalPreviewRouter
                    createdProposal={rowvalue}
                    rowvalue={rowvalue}
                    totalHour={totalHour}
                    selectedRange={selectedRange}
                    wrapInRow={false}
                  />
                  {/* <div className="d-flex justify-content-sm-between mt-4 mb-4 pb-4">
                    {rowvalue?.proposalName}
                  </div> */}
                  {status !== "Sent(Draft)" &&
                  rowvalue.status !== "Won" &&
                  rowvalue.status !== "Deal" ? (
                    <div className="">
                      {moment().diff(rowvalue?.proposalValidity) < 0 ? (
                        <div className="d-flex flex-row-reverse mb-2 pb-2 mr-3">
                          {rowvalue.status !== "Lost" && !isProposalDeclined ? (
                            <div className="d-flex flex-row-reverse">
                              {actionStatus === "" &&
                              rowvalue.status !== "Draft" ? (
                                <div className="d-flex flex-row-reverse">
                                  <div class="ml-1 mr-1">
                                    <Button
                                      className="btn btn-danger"
                                      type="button"
                                      onClick={() => {
                                        showModalForDecline();
                                      }}
                                    >
                                      Decline
                                    </Button>
                                  </div>
                                  <div class="ml-1 mr-1">
                                    <Button
                                      className="btn btn-primary"
                                      onClick={() => {
                                        showModalForAccept();
                                      }}
                                    >
                                      Accept
                                    </Button>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          ) : (
                            <div>
                              <Button type="primary" disabled={true} block>
                                Proposal is Declined
                              </Button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <Button type="primary" disabled={true} block>
                          Proposal has been Expired
                        </Button>
                      )}
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="d-flex flex-row-reverse mb-4 pb-4">
                    {rowvalue.status === "Won" ||
                    rowvalue.status === "Deal" ||
                    actionStatus === "Accept" ? (
                      <div className="d-flex flex-row-reverse mb-4 pb-4">
                        <Button type="primary" disabled={true} block>
                          Accepted
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                <div className="">
                  <Document
                    file={pdfViewUrl}
                    onLoadSuccess={onDocumentLoadSuccess}
                  >
                    {numOfPages.map((e) => (
                      <Page width="1300" pageNumber={e} />
                    ))}
                  </Document>
                </div>
              )}
            </div>
          </>
        </div>
      </div>

      <CustomizedDialogs
        isModalVisible={isModalVisible}
        handleOkModal={handleclose}
        handleCancelMOdal={handleclose}
        message={message}
        info={"Thank you"}
      />

      <Modal
        title="Accept Proposal"
        visible={isModalAcceptVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Accept"
        cancelText="Cancel"
      >
        <p>Any Comments if you have for us ?</p>
        <TextArea
          rows={4}
          value={acceptNotes}
          onChange={(e) => {
            setAcceptNotes(e.target.value || "");
          }}
        />
      </Modal>

      <Modal
        title="Decline Proposal"
        visible={isModalDeclineVisible}
        onOk={handleDecineOk}
        onCancel={handleDeclineCancel}
      >
        <div className="row">
          <div className="col-12">
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Search to Select"
              optionFilterProp="children"
              value={declineNote}
              onChange={(e) => {
                selectedDeclineNote(e || "");
              }}
            >
              {declineOption.map((e) => {
                return <Option value={e.value}>{e.name}</Option>;
              })}
            </Select>
            <div>
              {isDeclineNotes ? (
                <div className="mt-4">
                  <p>Any Comments if you have for us ?</p>
                  <TextArea
                    rows={4}
                    value={seclineTextNote}
                    onChange={(e) => {
                      setSeclineTextNote(e.target.value || "");
                    }}
                  />
                </div>
              ) : (
                ""
              )}
            </div>

            <div>
              {isDeclineReasonBlank ? (
                <p style={{ color: "red" }}>Please Enter Decline Reason </p>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </Modal>
      {/* Share Link Modal */}
      <Modal
        title="Share this proposal"
        visible={isShareModelVisible}
        onOk={handleShareOk}
        onCancel={handleShareCancel}
        okText="Copy URL"
        cancelText="Cancel"
      >
        <h5>Copy this private URL to share</h5>
        <p>
          Use this link to share the proposal with your team. When you are
          ready, anyone with signing authority can add their signature.
        </p>

        <Input placeholder="Basic usage" value={publicUrl} />
      </Modal>
    </>
  );
};
export default BusinessProposalComponent;
